module.exports = __webpack_public_path__ + "static/media/successWorkspace.15d07b3f.svg";